import React, { useState } from "react";
import Body from "./Body";
import "../../../../styles/Pages/Organizational/Management/Members/Members.style.css";
const Members = () => {
  const [addMemberModal, setAddMemberModal] = useState(false);
  const [addMemberDetails, setAddMemberDetails] = useState({});
  const _this = {
    addMemberModal,
    setAddMemberModal,
    addMemberDetails,
    setAddMemberDetails,
  };
  return <Body {..._this} />;
};

export default Members;
